module.exports = __webpack_public_path__ + "3d4bb1ad3f53d036140901ec63058c85.MP3";